import { defineComponent } from 'vue';
import DCApp from "./../Shared/App.vue";
import * as Vue from 'vue';
import DriverscloudComponent from "./../BackupDriver/DriverscloudComponent.vue";
import { VueSignalR } from './../../Scripts/js/signalrmonitoring.service';
import { createSignalRHubConnexion } from "./../Shared/DCSignalRConnection";
import { createPinia } from 'pinia';

let glan: string = "fr";
let g_dcWebSocketServiceUrl: string = "";

const mixin = defineComponent({
    components: { DriverscloudComponent },
    data() {
        return {
            lan: "fr",
            dcWebSocketServiceUrl:''
        };
    },
    created() {
      
    },

    mounted() {
        this.lan = glan;
        this.dcWebSocketServiceUrl = g_dcWebSocketServiceUrl;
    },
    methods: {
            
    }

});


export class BackupDriverComponent {
    public constructor() {
    }

    public Init(lan: string, dcWebSocketServiceUrl: string) {
        glan = lan;
        g_dcWebSocketServiceUrl = dcWebSocketServiceUrl;
        DCApp.mixins = [mixin];
        const app = Vue.createApp(DCApp);
        const pinia = createPinia();
        app.use(pinia);
        const connection = createSignalRHubConnexion(`${dcWebSocketServiceUrl}/SignalRDriversCloud`);
        app.use(VueSignalR, connection);
        app.mount('#rootpage');
    }
}
(<any>(window)).BackupDriverComponent = function () { return new BackupDriverComponent(); };